import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMorevert(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3.459q.67 0 1.148.477.477.476.477 1.148t-.477 1.147Q12.67 6.71 12 6.71t-1.148-.478a1.57 1.57 0 0 1-.477-1.147q0-.67.477-1.148.478-.477 1.148-.477m0 6.906q.67 0 1.148.477t.477 1.148-.477 1.147-1.148.478-1.148-.478a1.57 1.57 0 0 1-.477-1.147q0-.67.477-1.148.478-.477 1.148-.477m0 6.915q.67 0 1.148.478.477.477.477 1.147t-.477 1.148T12 20.53t-1.148-.477a1.56 1.56 0 0 1-.477-1.148q0-.671.477-1.147.478-.478 1.148-.478"
  }));
}
var IcMorevert = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMorevert));

export { IcMorevert as I };
